import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import IPortfolioPage from './iportfolio/IPortfolioPage';
import PhotoAlbumPage from './iportfolio/PhotoAlbumPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IPortfolioPage />} />
        <Route path="/album" element={<PhotoAlbumPage />} />
      </Routes>
    </Router>
  );
}

export default App;
